module.exports = __webpack_public_path__ + "static/media/logo-dir-lantas-polri@2x.922498f2.png";